<div class="unauthorized-container">
  <div class="error-card">
    <div class="error-header">
      <div class="error-icon">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor"/>
        </svg>
      </div>
      <h1 class="error-title">Accès Refusé</h1>
      <p class="error-subtitle">Vous n'avez pas les droits pour accéder à cette page</p>
    </div>
    
    <div class="error-content">
      <div class="error-details">
        <div class="detail-item">
          <span class="detail-icon">🔒</span>
          <span class="detail-text">Page réservée aux administrateurs</span>
        </div>
        <div class="detail-item">
          <span class="detail-icon">📧</span>
          <span class="detail-text">Contactez votre administrateur si nécessaire</span>
        </div>
      </div>
    </div>
    
    <div class="error-actions">
      <button class="btn-primary" (click)="retourAccueil()">
        <span class="btn-icon">🏠</span>
        Retour à l'accueil
      </button>
      <button class="btn-secondary" (click)="retourPrecedent()">
        <span class="btn-icon">⬅️</span>
        Page précédente
      </button>
    </div>
    
    <div class="error-footer">
      <p class="help-text">Besoin d'aide ? Contactez le support technique</p>
      <div class="contact-info">
        <span class="contact-item">📞 Support: +33 1 23 45 67 89</span>
        <span class="contact-item">✉️ Email: support@numero-vip.fr</span>
      </div>
    </div>
  </div>
</div>
